// extracted by mini-css-extract-plugin
module.exports = {"loader":"Loader_loader__3VB91","lds-ring":"Loader_lds-ring__yvSWc"};